import { Box } from "@mui/material";
import EmptyState from "../shared/EmptyState";
import ChatMessage from "./ChatMessage";

const SingleChatMessages = ({ messages, currentImageUrl, onImageSelect }) => {
  if (messages.length === 0) {
    return <EmptyState />;
  }

  const firstUserMessageIndex = messages.findIndex(
    (message) => message.role === "user"
  );

  return (
    <Box sx={{ display: "flex", flexDirection: "column", gap: 2 }}>
      {messages.map((message, index) => (
        <ChatMessage
          key={message.id}
          message={message}
          currentImageUrl={currentImageUrl}
          onImageSelect={onImageSelect}
          isFirstUserMessage={
            message.role === "user" && index === firstUserMessageIndex
          }
        />
      ))}
    </Box>
  );
};

export default SingleChatMessages;
